import { Module } from 'src/domain';
import { useUpdateModuleInheritance } from 'src/hooks/split-levels/useUpdateModuleInheritance';

export const useProductLineSplitUpdateInheritance = (standalone = true) =>
    useUpdateModuleInheritance(Module.ProductLineSplit, standalone);
